import { Injectable, inject } from '@angular/core';
import { EnergyConsumptionOptions } from '@nx-customer-apps/shared/interfaces';
import { Question } from '@nx-customer-apps/shared/utils';
import { CommonFormService } from '../../../../services/common-form.service';

@Injectable({
    providedIn: 'root'
})
export class EnergyConsumptionFormService {
    private commonFormService = inject(CommonFormService);

    public getEnergyConsumptionQuestions(options: EnergyConsumptionOptions): Question[] {
        const questions = [];

        if (options.selectedSource && options.selectedUnit) {
            const energyRequiredPerYear = this.commonFormService.getEnergyRequiredPerYear(options);
            questions.push(energyRequiredPerYear);
        }

        const nonHeatingElectricityPerYear = this.commonFormService.nonHeatingElectricityConsumption(options);
        questions.push(nonHeatingElectricityPerYear);
        return questions;
    }
}
